module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavyrain-2ca10e1b8b47a6b9e5b2532765f6366a.png";